import { Box, type BoxProps } from "@mui/material";
import type { ReactElement } from "react";

export interface IFloatingElement {
  position?: "left" | "right" | "top" | "bottom";
  slotProps?: {
    box?: Partial<BoxProps>;
  };
  children: ReactElement;
}

const getTransform = (position?: IFloatingElement["position"]) => {
  switch (position) {
    case "left":
      return "translate(0%, -50%)";
    case "right":
      return "translate(-100%, -50%)";
    case "top":
      return "translate(-50%, 0%)";
    case "bottom":
      return "translate(-50%, -100%)";
    default:
      return "translate(-50%, -50%)";
  }
};

export const FloatingElement = ({ position, slotProps, children }: IFloatingElement) => {
  return (
    <Box
      component="span"
      {...slotProps?.box}
      sx={{
        position: "relative",
        "& > *": {
          position: "absolute !important",
          transform: `${getTransform(position)} !important`,
          top: "50%",
          left: "50%",
        },
        ...slotProps?.box?.sx,
      }}
    >
      {children}
    </Box>
  );
};
